import { render } from "./newPlan.vue?vue&type=template&id=959a06ae&scoped=true"
import script from "./newPlan.vue?vue&type=script&lang=js"
export * from "./newPlan.vue?vue&type=script&lang=js"

import "./newPlan.vue?vue&type=style&index=0&id=959a06ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-959a06ae"]])

export default __exports__